import { apiClient } from "../../lib/axios";

export interface ClientDashboardSetting {
  dashboard_key: string;
  is_enabled: boolean;
  ai_enabled?: boolean | null;
}

export interface ClientDashboardSettingsResponse {
  data: ClientDashboardSetting[];
}

export const dashboardSettingsApi = {
  listCurrentClientDashboardSettings: async (): Promise<ClientDashboardSettingsResponse> => {
    const response = await apiClient.get("/client/dashboard-settings");
    return response.data;
  },
};
